// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media parameters */
/* Colors */
/* Fonts */
.RightPanel_tab__\\+8tK2 {
  position: absolute;
  right: 0;
  display: flex;
  background-color: #FFFFFF;
  height: 100%;
}

.RightPanel_tab-left__NpN2N {
  top: 0;
  left: 0;
  translate: -100%;
  height: 100%;
}

.RightPanel_tab-right__Sh5qk {
  top: 0;
  right: 0;
  translate: 100%;
}

.RightPanel_tab-active__hlRmo {
  translate: 0;
}

.RightPanel_tab-content__aKaXS {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: stretch;
  padding: 10px;
  height: 100%;
  outline: 1px solid #8000FF;
}

.RightPanel_tab-pane__Cj9ar {
  min-width: 270px;
  width: 17vw;
  display: none;
  height: 100%;
}

.RightPanel_tab-component__ZH-FT {
  display: flex;
  flex-grow: 1;
  overflow-y: auto;
  scrollbar-width: thin;
}

.RightPanel_tab-pane-active__Mn2-b {
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 16px;
  justify-content: stretch;
}

.RightPanel_tab-nav__61OYv {
  position: absolute;
  left: 0;
  top: 20px;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style-type: none;
  translate: -100%;
}

.RightPanel_tab-nav-item__g40Oe {
  display: flex;
}

.RightPanel_tab-button__eNQvd {
  padding: 4px;
  font-family: "Roboto Mono", "Arial", monospace;
  background-color: #FFFFFF;
  cursor: pointer;
  border: none;
  border: 1px solid #8000FF;
  border-radius: 5px 0 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.RightPanel_tab-button-active__viSe0 {
  color: #8000FF;
  border-right: 1px solid #FFFFFF;
}

.RightPanel_tab-project-buttons__XKmPU {
  display: flex;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables.sass","webpack://./src/components/base/rightPanel/RightPanel.module.sass"],"names":[],"mappings":"AAAA,qBAAA;AASA,WAAA;AAWA,UAAA;AClBA;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,yBDIS;ECHT,YAAA;AAEJ;;AAAA;EACI,MAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;AAGJ;;AADA;EACI,MAAA;EACA,QAAA;EACA,eAAA;AAIJ;;AAFA;EACI,YAAA;AAKJ;;AAHA;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,aAAA;EACA,YAAA;EACA,0BAAA;AAMJ;;AAJA;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;AAOJ;;AAJA;EACI,aAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AAOJ;;AALA;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,wBAAA;AAQJ;;AANA;EACI,kBAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,qBAAA;EACA,gBAAA;AASJ;;AAPA;EACI,aAAA;AAUJ;;AARA;EACI,YAAA;EACA,8CDhDS;ECiDT,yBD5DS;EC6DT,eAAA;EACA,YAAA;EACA,yBAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAWJ;;AATA;EACI,cDnEK;ECoEL,+BAAA;AAYJ;;AAVA;EACI,aAAA;EACA,QAAA;AAaJ","sourcesContent":["/* Media parameters */\r\n$mobile-max: 768px\r\n$tablet-max: 1210px\r\n$desktop-max: 1440px\r\n\r\n// Отступы от краев экрана\r\n$mobile-offset: 8px\r\n$desktop-offset: 64px\r\n\r\n/* Colors */\r\n$base-white: #FFFFFF\r\n$base-black: #333333\r\n$base-shadow: #0500FF40\r\n$accent: #8000FF\r\n$accent-darken: #6000BF\r\n$link: #007AFF\r\n$error: #D60056\r\n// Также отвечает и за disabled\r\n$placeholder: #33333360\r\n\r\n/* Fonts */\r\n$fm-primary: 'Roboto Mono', 'Arial', monospace","@use \"../../../assets/styles/variables\" as *\r\n\r\n.tab\r\n    position: absolute\r\n    right: 0\r\n    display: flex\r\n    background-color: $base-white\r\n    height: 100%\r\n\r\n.tab-left\r\n    top: 0\r\n    left: 0\r\n    translate: -100%\r\n    height: 100%\r\n\r\n.tab-right\r\n    top: 0\r\n    right: 0\r\n    translate: 100%\r\n\r\n.tab-active\r\n    translate: 0\r\n\r\n.tab-content\r\n    display: flex\r\n    position: relative\r\n    flex-direction: column\r\n    justify-content: stretch\r\n    padding: 10px\r\n    height: 100%\r\n    outline: 1px solid $accent\r\n\r\n.tab-pane\r\n    min-width: 270px\r\n    width: 17vw\r\n    display: none\r\n    height: 100%\r\n    //background-color: $base-white\r\n\r\n.tab-component\r\n    display: flex\r\n    flex-grow: 1\r\n    overflow-y: auto\r\n    scrollbar-width: thin\r\n\r\n.tab-pane-active\r\n    display: flex\r\n    position: relative\r\n    flex-direction: column\r\n    gap: 16px\r\n    justify-content: stretch\r\n\r\n.tab-nav\r\n    position: absolute\r\n    left: 0\r\n    top: 20px\r\n    margin: 0\r\n    padding: 0\r\n    display: flex\r\n    flex-direction: column\r\n    gap: 4px\r\n    list-style-type: none\r\n    translate: -100%\r\n\r\n.tab-nav-item\r\n    display: flex\r\n\r\n.tab-button\r\n    padding: 4px\r\n    font-family: $fm-primary\r\n    background-color: $base-white\r\n    cursor: pointer\r\n    border: none\r\n    border: 1px solid $accent\r\n    border-radius: 5px 0 0 5px\r\n    display: flex\r\n    justify-content: center\r\n    align-items: center\r\n\r\n.tab-button-active\r\n    color: $accent\r\n    border-right: 1px solid $base-white\r\n\r\n.tab-project-buttons\r\n    display: flex\r\n    gap: 8px"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab": `RightPanel_tab__+8tK2`,
	"tab-left": `RightPanel_tab-left__NpN2N`,
	"tab-right": `RightPanel_tab-right__Sh5qk`,
	"tab-active": `RightPanel_tab-active__hlRmo`,
	"tab-content": `RightPanel_tab-content__aKaXS`,
	"tab-pane": `RightPanel_tab-pane__Cj9ar`,
	"tab-component": `RightPanel_tab-component__ZH-FT`,
	"tab-pane-active": `RightPanel_tab-pane-active__Mn2-b`,
	"tab-nav": `RightPanel_tab-nav__61OYv`,
	"tab-nav-item": `RightPanel_tab-nav-item__g40Oe`,
	"tab-button": `RightPanel_tab-button__eNQvd`,
	"tab-button-active": `RightPanel_tab-button-active__viSe0`,
	"tab-project-buttons": `RightPanel_tab-project-buttons__XKmPU`
};
export default ___CSS_LOADER_EXPORT___;
